/**
 * 实用案例合集 Compositions
 * 
 * 包含 3 个高质量实用案例：
 * 1. EducationalSlides - 教育类知识点讲解
 * 2. ProductShowcase - 商业类产品展示
 * 3. DataComparison - 信息图表演示
 * 
 * 质量标准：参考足球视频（9.0/10）
 * 
 * @author 龙虾菌 🦞
 * @date 2026-03-10
 */

import { Composition } from 'remotion';
import { EducationalSlides } from '../effects/EducationalSlides';
import { ProductShowcase } from '../effects/ProductShowcase';
import { DataComparison } from '../effects/DataComparison';
import { FluidGradientAnimation } from '../effects/FluidGradientAnimation';
import { BounceTypographyAnimation } from '../effects/BounceTypographyAnimation';

export const PracticalCasesCompositions: React.FC = () => {
  return (
    <>
      {/* ==================== 教育类案例 ==================== */}
      <Composition
        id="EducationalSlides"
        component={EducationalSlides}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
      />

      {/* ==================== 商业类案例 ==================== */}
      <Composition
        id="ProductShowcase"
        component={ProductShowcase}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
      />

      {/* ==================== 信息图表案例 ==================== */}
      <Composition
        id="DataComparison"
        component={DataComparison}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
      />

      {/* ==================== 2026-03-10 新效果 ==================== */}
      {/* #492 Fluid Gradient Animation - 流体渐变动画（待评分） */}
      <Composition
        id="FluidGradientAnimation"
        component={FluidGradientAnimation}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={{
          color1: '#667eea',
          color2: '#764ba2',
          color3: '#f093fb',
          color4: '#f5576c',
          speed: 1,
          layers: 3,
        }}
      />

      {/* #493 Bounce Typography Animation - 弹性文字动画（待评分） */}
      <Composition
        id="BounceTypographyAnimation"
        component={BounceTypographyAnimation}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={{
          text: 'BOUNCE',
          fontSize: 150,
          color: '#00ff88',
          staggerDelay: 5,
          scale: 1,
        }}
      />
    </>
  );
};
